import { EnvironmentProviders, InjectionToken, makeEnvironmentProviders } from '@angular/core';
import type { FirebaseApp as FbFirebaseApp } from 'firebase/app';
import {
  deleteApp as rawDeleteApp,
  getApp as rawGetApp,
  getApps as rawGetApps,
  initializeApp as rawInitializeApp,
  onLog as rawOnLog,
  registerVersion as rawRegisterVersion,
  setLogLevel as rawSetLogLevel,
} from 'firebase/app';
import { kdvWrap } from '@fido/firebase';

// Wrapped firebase/app functions. Mirrors @angular/fire's
// _zoneWrap(fn, true) declarations from angular-fire-app.mjs.
export const deleteApp = kdvWrap(rawDeleteApp, true);
export const getApp = kdvWrap(rawGetApp, true);
export const getApps = kdvWrap(rawGetApps, true);
export const initializeApp = kdvWrap(rawInitializeApp, true);
export const onLog = kdvWrap(rawOnLog, true);
export const registerVersion = kdvWrap(rawRegisterVersion, true);
export const setLogLevel = kdvWrap(rawSetLogLevel, true);

// Re-exports — these are not wrapped because they're not functions:
// FirebaseError is a class, FirebaseOptions and FirebaseAppSettings are types.
export { FirebaseError } from 'firebase/app';
export type { FirebaseOptions, FirebaseAppSettings } from 'firebase/app';

export type FirebaseApp = FbFirebaseApp;
export const FirebaseApp = new InjectionToken<FbFirebaseApp>('@fido/firebase.app');

export function provideFirebaseApp(factory: () => FbFirebaseApp): EnvironmentProviders {
  return makeEnvironmentProviders([{ provide: FirebaseApp, useFactory: factory }]);
}
